module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDQgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8Y2lyY2xlIGN4PSIyIiBjeT0iMiIgcj0iMiIgZmlsbD0id2hpdGUiLz4NCjxjaXJjbGUgY3g9IjIiIGN5PSIxMCIgcj0iMiIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-hour-2026-sale/time_dot.svg
// module id = glrP
// module chunks = 2